var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.homeValue)?_c('div',[_c('PopulationAgeChart',{staticClass:"-mx-6 lg:mx-0",attrs:{"population":_vm.homeValue.Property.JSONContext.contesto.popolazione}}),_vm._v(" "),_c('FamiliesChart',{staticClass:"-mx-6 lg:mx-0",attrs:{"population":_vm.homeValue.Property.JSONContext.contesto.popolazione}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }